import { Button, Card } from '../../../../common/components'

import styles from './index.module.css'

type ConfirmAnnualInsuranceCoverageProps = {
  onConfirmCoverage?: () => void
}

const ConfirmAnnualInsuranceCoverage = ({ onConfirmCoverage = () => {} }: ConfirmAnnualInsuranceCoverageProps) => {
  return (
    <Card className={styles.wrap}>
      <div className={styles.icon}>
        <i className="fad fa-exclamation-triangle"></i>
      </div>

      <h3>
        <b>Confirm your annual insurance coverage</b>
      </h3>

      <p className={styles.paragraph}>
        Per federal regulations, in order to start your ICHRA benefits, you must attest that you currently have, or will
        obtain, coverage under a qualified individual health insurance policy that provides minimum essential coverage
        (MEC) on or before your benefit start date.
      </p>

      <Button type={'primary'} onClick={onConfirmCoverage}>
        Confirm Coverage
      </Button>
    </Card>
  )
}

export default ConfirmAnnualInsuranceCoverage
